import { CancelToken, COMMAND, Connection, ServerCommand } from "../connection.client";

export function getAllProfilesRequest(callback: Function): CancelToken {
  const messageToServer = [
    [COMMAND, "money_machine_command"],
    ["subcommand", "get_all_profiles"]
  ];

  return Connection.getInstance().sendWithStreamingResponse(messageToServer as ServerCommand, (response: string) => {
      callback(response);  //(xml);
  });
}

export function getProfileRequest(profileId: string, callback: Function): CancelToken {
  const messageToServer = [
    [COMMAND, "money_machine_command"],
    ["subcommand", "get_profile"],
    ["profile_id", profileId]
  ];

  return Connection.getInstance().sendWithStreamingResponse(messageToServer as ServerCommand, (response: string) => {
      callback(response);  //(xml);
  });
}

export function addProfileRequest(broker: string, userAccountId: string, profileName: string, profileDescription: string, profileDefault: boolean, settingsStr: string, callback: Function): CancelToken {
  const base64Settings = btoa(settingsStr);
  const messageToServer = [
    [COMMAND, "money_machine_command"],
    ["subcommand", "add_profile"],
    ["broker", broker],
    ["user_account_id", userAccountId],
    ["profile_name", profileName],
    ["profile_description", profileDescription],
    ["profile_default", profileDefault],
    ["settings", base64Settings],
  ];

  return Connection.getInstance().sendWithStreamingResponse(messageToServer as ServerCommand, (response: string) => {
      callback(response);  //(xml);
  });
}

export function updateProfileRequest(profileId: string, broker: string, userAccountId: string, profileName: string, profileDescription: string, profileDefault: boolean, settingsStr: string, callback: Function): CancelToken {
  const base64Settings = btoa(settingsStr);
  const messageToServer = [
    [COMMAND, "money_machine_command"],
    ["subcommand", "update_profile"],
    ["profile_id", profileId],
    ["broker", broker],
    ["user_account_id", userAccountId],
    ["profile_name", profileName],
    ["profile_description", profileDescription],
    ["profile_default", profileDefault],
    ["settings", base64Settings],
  ];

  return Connection.getInstance().sendWithStreamingResponse(messageToServer as ServerCommand, (response: string) => {
      callback(response);  //(xml);
  });
}

export function deleteProfileRequest(profileId: string, callback: Function): CancelToken {
  const messageToServer = [
    [COMMAND, "money_machine_command"],
    ["subcommand", "delete_profile"],
    ["profile_id", profileId],
  ];

  return Connection.getInstance().sendWithStreamingResponse(messageToServer as ServerCommand, (response: string) => {
      callback(response);  //(xml);
  });
}
